import store from '@/store'
import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import routes from '@/router/routes'
import { MutationTypes } from '@/store/mutation-types'
import ApiClient from '@/services/api-client'
import { APP_CCP } from '@/utils/constants'
import { Utils } from '@/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to: Route, from: Route, next) => {
  // First thing is to check if user is authenticated
  if (to.meta && to.meta.requiresAuth && !store.getters.isUserAuthenticated) {
    // Save return origin path
    store.commit(MutationTypes.SET_ORIGIN_URL, to.fullPath)

    // Show modal only if not going to login and redirect from /
    // which means the user tried to navigate to a protected path
    next({
      name: 'Login',
      params: {
        to: to.fullPath
      }
    })
    return
  }

  if (to.name === 'Login' && store.getters.isUserAuthenticated) {
    next({ name: 'Home' })
  }

  // Check if route requires specific profiles
  if (to.meta && to.meta.requiredProfiles) {
    const userProfile = store.state.user.account?.profile
    const requiredProfiles = to.meta.requiredProfiles as string[]

    if (!userProfile || !requiredProfiles.includes(userProfile)) {
      next({ name: 'Unauthorized' })
      return
    }
  }

  // Check if route requires a role in the CCP app (same rule as the v-security directive)
  if (to.meta && to.meta.requiredRole) {
    if (!Utils.hasCcpRole(store.state.user.account, to.meta.requiredRole)) {
      next({ name: 'Unauthorized' })
      return
    }
  }

  next()
})

router.afterEach((to: Route) => {
  if (store.getters.isUserAuthenticated) {
    const url = to.fullPath
    ApiClient.registerNavigation(APP_CCP, url)
  }
})

export default router
